import React from "react";
import "./MainContent.scss";
export default function MainContent({ children }) {
  return (
    <section
      className={`grid grid-cols-1 min-h-screen bg-slate-300 dark:bg-mainDark main-content-dashboard`}
    >
      {children}
    </section>
  );
}
